// // Email configuration for EmailJS service
// export const getEmailConfig = () => {
//   return {
//     publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "bHJaAgy4hDQeZgrPp",
//     serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_emskhtq",
//     userTemplateId: process.env.REACT_APP_EMAILJS_USER_TEMPLATE_ID || "template_vqwi0ri",
//     adminTemplateId: process.env.REACT_APP_EMAILJS_ADMIN_TEMPLATE_ID || "template_1m3ha7k",
//     adminEmail: process.env.REACT_APP_ADMIN_EMAIL || "contact@dgfuturetech.com",
//     replyToEmail: process.env.REACT_APP_REPLY_TO_EMAIL || "info@dgfuturetech.com",

//     publicKey1: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "KJva8aTlfsI0P1wss",
//     serviceId1: process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_e7qgbwl",
//     userTemplateId1: process.env.REACT_APP_EMAILJS_USER_TEMPLATE_ID || "template_l1omtzk",
//     adminTemplateId1: process.env.REACT_APP_EMAILJS_ADMIN_TEMPLATE_ID || "template_gs3p8tk",
//     adminEmail1: process.env.REACT_APP_ADMIN_EMAIL || "careers@dgfuturetech.com",
//     replyToEmail1: process.env.REACT_APP_REPLY_TO_EMAIL || "info@dgfuturetech.com"
//   };
// }; 

// Email configuration for EmailJS service
export const getEmailConfig = () => {
  return {
    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "KJva8aTlfsI0P1wss",
    serviceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_xtksca9",
    userTemplateId: process.env.REACT_APP_EMAILJS_USER_TEMPLATE_ID || "template_l1omtzk",
    adminTemplateId: process.env.REACT_APP_EMAILJS_ADMIN_TEMPLATE_ID || "template_gs3p8tk",
    adminEmail: process.env.REACT_APP_ADMIN_EMAIL || "contact@dgfuturetech.com",
    replyToEmail: process.env.REACT_APP_REPLY_TO_EMAIL || "info@dgfuturetech.com",

    publicKey1: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || "KJva8aTlfsI0P1wss",
    serviceId1: process.env.REACT_APP_EMAILJS_SERVICE_ID || "service_e7qgbwl",
    userTemplateId1: process.env.REACT_APP_EMAILJS_USER_TEMPLATE_ID || "template_l1omtzk",
    adminTemplateId1: process.env.REACT_APP_EMAILJS_ADMIN_TEMPLATE_ID || "template_gs3p8tk",
    adminEmail1: process.env.REACT_APP_ADMIN_EMAIL || "careers@dgfuturetech.com",
    replyToEmail1: process.env.REACT_APP_REPLY_TO_EMAIL || "info@dgfuturetech.com"
  };
}; 

